import { render, staticRenderFns } from "./AuthenSch.vue?vue&type=template&id=f3218226&scoped=true&"
import script from "./AuthenSch.vue?vue&type=script&lang=js&"
export * from "./AuthenSch.vue?vue&type=script&lang=js&"
import style0 from "./AuthenSch.vue?vue&type=style&index=0&id=f3218226&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3218226",
  null
  
)

export default component.exports